import React, { useState } from 'react'
import { Calendar } from '@/components/ui/calendar'
import { format } from 'date-fns'
import CalendarIcon from '@/assets/builder/icon/CalendarIcon'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@/components/ui/popover'

interface DateProps {
    questionId: string
    selectedValue?: Date
}

const Date: React.FC<DateProps> = ({ questionId, selectedValue }) => {
    const [selectedDate, setSelectedDate] = useState<Date | undefined>(
        selectedValue
    )

    return (
        <div className="mt-4 w-[438px]">
            <Popover>
                <PopoverTrigger>
                    <Button
                        variant={'outline'}
                        className={cn(
                            'w-[438px] h-[52px] justify-between text-left border-[#DEDEDE]',
                            !selectedDate && 'text-muted-foreground'
                        )}
                        disabled
                    >
                        {selectedDate ? (
                            format(selectedDate, 'yyyy-MM-dd')
                        ) : (
                            <span>YYYY-MM-DD</span>
                        )}
                        <CalendarIcon />
                    </Button>
                </PopoverTrigger>
            </Popover>
        </div>
    )
}

export default Date
